import React from 'react';
import { useNavigate } from 'react-router-dom';

interface FixedBottomCTAProps {
  to?: string;
  onClick?: () => void;
  icon: React.ReactNode;
  text: string;
}

/**
 * Renders a full-width, fixed-to-bottom CTA as a single <button>.
 * If `to` is provided, clicking will call navigate(to). Otherwise it calls onClick().
 * That way it’s always the same element with the same styling.
 */
const FixedBottomCTA: React.FC<FixedBottomCTAProps> = ({
  to,
  onClick,
  icon,
  text,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else if (onClick) {
      onClick();
    }
  };

  // One single class list for height/padding/bg/font, etc.
  const baseClasses =
    'flex items-center justify-center gap-2 w-full py-3 bg-black text-white rounded-full text-base font-medium hover:bg-gray-800 transition';

  return (
    <div
      className="fixed inset-x-0 px-4 z-[49]"
      /* sit just above the nav (base + safe-bottom) with an 8px gap */
      style={{ bottom: 'calc(var(--nav-height-base) + var(--safe-bottom) + 8px)' }}
    >
      <button onClick={handleClick} className={baseClasses} type="button">
        {icon}
        <span>{text}</span>
      </button>
    </div>
  );
};

export default FixedBottomCTA;
